// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"k8-z","paperCutsLineHeight":"l8-z"};